<template>
  <span>
    <!-- <img :src="arrow" /> -->
    <r-icon name="icon-actions_select_down" style="color: black; font-size: 12px"/>
  </span>
</template>
<script lang="ts" setup>
// import arrow from './arrow.svg?url';
// import { defineComponent } from 'vue'

// export default defineComponent({
//   setup() {
    
//   },
// })
</script>
